import { useCallback } from 'react';
import useSetPdpSelectedProtectionPlanId from './useSetPdpSelectedProtectionPlanId';

const useResetPdpSelectedProtectionPlanId = () => {
  const setPdpSelectedProtectionPlanId = useSetPdpSelectedProtectionPlanId();

  const resetPdpSelectedProtectionPlanId = useCallback(() => {
    setPdpSelectedProtectionPlanId(0);
  }, [setPdpSelectedProtectionPlanId]);

  return resetPdpSelectedProtectionPlanId;
};

export default useResetPdpSelectedProtectionPlanId;
